import { Container } from "react-bootstrap";

export default function LightSection({ children }: any) {
    return (
        <Container fluid className="bg-white">
            <Container className="py-3">{children}</Container>
        </Container>
    );
}
